"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/Link.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _keyboard = require('web/services/keyboard');










const SettingsLink = ({
  withPlusIcon,
  role,
  theme = 'default',
  onClick,
  className,
  children,
}) => (
  // No href, so tabIndex and Enter/Space make it reachable and pressable.
  _react2.default.createElement('a', {
    role: role,
    tabIndex: 0,
    onKeyDown: _keyboard.onButtonKeyDown,
    className: _classBuilder2.default.call(void 0, 
      "settings--link",
      theme === 'danger' && 'settings--link--danger',
      withPlusIcon && "settings--link--plus",
      className,
    ),
    onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}

    ,  children 
  )
)

exports. default = SettingsLink
